import { Bot, ClipboardCheck, FileText, Info, LayoutGrid } from 'lucide-react';

/** Eén item in de event-navigatie van de sidebar. */
export type NavItem = {
  /** Route-segment achter `/events/:eventId/`. */
  to: string;
  label: string;
  icon: typeof FileText;
  /** Korte tag naast het label, gerenderd als neutrale badge (bv. 'Beta'). */
  tag?: string;
  /** Sleutel naar de teller die rechts in de rij wordt gerenderd. */
  badgeKey?: 'documents';
};

export const navItems: ReadonlyArray<NavItem> = [
  { to: 'overview', label: 'Overzicht', icon: LayoutGrid },
  { to: 'report', label: 'Validatie', icon: ClipboardCheck },
  { to: 'information', label: 'Informatie', icon: Info },
  { to: 'documents', label: 'Documenten', icon: FileText, badgeKey: 'documents' },
  { to: 'assistant', label: 'Assistent', icon: Bot, tag: 'Beta' },
];
